// Shared success-toast copy for the "add player(s) to list" modals (SaveToListModal single-player,
// AddPlayerToListModal multi-player). Kept in one place so a design copy tweak lands in both.

export const PLAYER_ADDED_TITLE = 'Player Successfully Added';
export const FALLBACK_PLAYER_LABEL = 'This player';
export const VIEW_LIST_LABEL = 'View List';
